// extracted by mini-css-extract-plugin
module.exports = {"popup":"style_popup__1W2Bc","title":"style_title__1iZR7","itemsWrapper":"style_itemsWrapper__3KMco","active":"style_active__3WTmG"};